import { render, staticRenderFns } from "./PurchaseFailure.vue?vue&type=template&id=786ad132&"
import script from "./PurchaseFailure.vue?vue&type=script&lang=js&"
export * from "./PurchaseFailure.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseFailure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports